module.exports = __webpack_public_path__ + "static/media/Gotham-MediumItalic.3d3facbb.ttf";